import ManagersContainer from '../Managers/Container'

export default function ZoneManagers({ selectedZone }) {
  return <ManagersContainer selectedZone={selectedZone} />
}
